import { SVGAttributes } from 'react';
import { Keys } from '../../../../patient-types';
import BodySelectButton from './BodySelectButton';

const DentalLowerButtons = ({
  selectedKeys,
  ...props
}: SVGAttributes<SVGElement> & {
  selectedKeys: Keys;
}) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={315} height={315} fill='none' {...props}>
      <path
        fill='#F2F4FC'
        d='M13.5 311.107 18 311l6 .5 10.5 2.5 6.5-.5 5-2.5 3-5 1-4.5 1.5-4.5 3.67-8 .33-4.5-1-5-2-3.5-4-3.5-11.615-5.382 12.349-3.893 4.542-4.542.649-5.19 1.297-6.489 4.542-7.786 1.298-7.137-1.947-5.84-3.893-6.488-5.388-4.8L57.5 207l2.5-6 3.5-11.5 3-10-.437-4.5-1.563-5.5-3-4-7.5-3-3-3-5.5-3 5.5-2 7-4 4-5.5 2.251-8.5-.751-3.684-2-4.316L52 120l-1-4.077 6-.923 5-4 2.251-3.5 1.812-6L65.5 97 63 88.5 56.5 82l3.155-1.5 4.596-1.859H82.956l4.66-1.747L92.5 71V59.5L90 53.593h3.5l10 3.407h6l4.913-2.5L116.5 48V32.5l3-1 7.5 7 4.5 4.5 6.5 4 7.5-1 3.5-3 2-4.5 3-11.5 3.52-6.029.98-10.471-3.5-2-8-3.5-5.5-.5-5-.5-10 2.5-6 2-5 5-3 5.5-5-5.5-4.5-.5-17 5-8 5-3 3.5-2.5 7h-4L67 34l-7.345 1.534-6.408 2.33-7.573 2.913L44 43l-1.82 5.5-.68 4.5-1.651 7.5.583 5L44 72l-7.646 1.981-9.903 4.66-5.89 4.078-3.43 6.99.582 5.825 2.849 10.486 4.66 8.155L27.5 115l-2.278 2L19 121l-5.947 4.826-2.33 6.99 2.33 8.184 2.447 7 3 5.5-4.5 2-3.5 2.5-3.161 4.404L5 170l.762 11v5L5 190.5v5l1.5 4.5 3.803 6 5.84 3.372-5.84 1.946-4.541 2.595-3.893 4.542-.65 4.542 1.298 5.84v8.435l.65 7.786 1.297 8.435 5.84 5.839 6.585 3.761-5.19 1.297-3.894 3.893L5.5 270.5l-3 6-1 5 1.115 6.897L2.5 291.5 2 299l2 5.5 3.157 4.012 6.343 2.595Z'
      />
      <path
        fill='#F2F4FC'
        d='M303.153 311.107h-6.488l-8.435 1.298L277.848 315l-6.488-1.947-4.542-6.488-4.542-10.381-3.244-7.138.649-7.786 4.542-7.786 13.744-6.356-12.349-3.893-4.542-4.542-.649-5.19-1.298-6.489-4.542-7.786-1.297-7.137 1.946-5.84 3.893-6.488 5.388-4.8-5.019-5.832-3.893-5.84-3.244-10.381-3.244-9.733-.649-6.488.649-5.84 4.383-5.339 9-4.5 5-6-6.5-3.5-4.5-3.5-2.5-4-1.5-4.5-.5-4.5.5-4.5 2-4 3-3 3-3.5-1.5-3-8.4-3.5-4.6-7-1-5 .5-5 3.289-7.5 3.711-4.5 5-3.5.5-1.5-6-1-2.5.5h-9l-4.5-.5-5-.5-5.5-3-2.5-5.5V61l1.905-6-.405-3.5-10 4.5-5 .5-5 .5-4.5-2-2.5-4-1.5-9 1-6.5-.5-6.5-1.5 3-3.5 2.5-4 4.5-4.537 4-3.463 3-5 1.185-5-1.185-4-2.31-2-4.69-2-5-3-12.5-1-1 .5-9 3-5 5-1.5 7-1h5.5l4.463 1L191 8l5 2 3 5.5 4.352.5 7.148-3 7.415 1.563L229.5 19l7 4.5 2.5 3 1.5 4.5 2 5 5-3 6 .5 7 2.5 6 2.5 4 2 2 5.5 1 6 1 5.5.5 5.5-2 5.5-2 3 10.5 4 7.5 4 3 3 1.5 3.5.5 4-1 9.5-1 5-2.5 4.5-4 5 .571 1.923L290.5 118l3.5 2.5 7 4.5 3.129 7.816L303 139.5l-1.5 4-4.5 7.5v2.5l4 1.5 3 2.5 3.513 4.904 2.595 7.137L309.5 177l-1 5 1.5 8.5v5l-1.5 4.5-3.952 6-5.839 3.372 5.839 1.946 4.542 2.595 3.893 4.542.649 4.542-1.298 5.84v8.435l-.649 7.786-1.297 8.435-5.84 5.839-6.586 3.761 5.191 1.297 3.893 3.893 3.244 4.542 2.596 6.489.649 5.19-1.298 3.893-.649 5.191v9.733l-3.893 5.191-4.542 2.595Z'
      />
      <path
        stroke='#3455FC'
        strokeDasharray='5 5'
        strokeLinecap='round'
        strokeWidth={1.5}
        d='M120 31.674c3.642 2.77 5.898 6.508 9.5 9.326 2.662 2.09 5.348 5.782 9 6 7.665.458 10.915-2.831 13-10.5 1.046-3.848 2.02-8.758 3.5-12.5M224.5 51.3c-5.23 3.45-11.336 5.066-17.642 5.873-6.809.874-10.793-5.577-10.647-13.635.05-2.738.35-5.407.796-8.038M261.261 75.894c13.258-4.773 16.374-8.524 11.508-26.87-1.031-3.897-.39-8.238-5.275-10.01-5.406-1.96-10.572-4.938-16.116-6.046-4.346-.865-8.505 1.437-11.406 5.51a130.35 130.35 0 0 1-9.308 11.593M271.388 72c5.902.75 10.969 3.985 16.255 6.853 4.987 2.704 6.71 7.052 6.298 12.587-.519 6.965-1.091 13.955-5.816 19.564-3.756 4.466-7.764 6.284-13.045 5.959-4.602-.281-9.187-1.255-13.885-.212-5.506 1.224-12.286-4.098-14.34-8.539-2.906-6.278-2.36-12.6 1.375-18.415 3.183-4.96 7.004-8.708 12.055-10.8M194.384 32.283c-3.464 2.945-5.747 6.446-9.384 9.217-2.653 2.017-4.578 5.284-8.251 5.469-6.622.334-11.686-1.212-14.078-10.469-1.959-7.574-5.18-16.06-4.562-24.2.265-3.447 1.683-5.798 4.56-6.521 4.29-1.078 8.831-2.007 13.187-1.73 5.882.375 11.672 2.068 17.202 4.29 4.428 1.781 6.698 5.958 5.713 10.628-.944 4.467-2.237 8.837-3.117 13.316M50 158.5c.461.467 3.58 3.715 4.128 3.854 11.897 2.988 14.734 12.702 10.212 24.641-1.384 3.653-2.998 7.333-3.599 11.146-.665 4.232-2.135 7.858-4.768 11.114-3.224 3.985-8.008 6.892-12.412 5.278-3.823-1.406-8.175-2.145-12.061-3.033M295.887 208.702c-8.373 1.357-16.585 2.859-24.663 5.83-4.404 1.615-9.188-1.292-12.412-5.278-2.633-3.255-4.103-6.881-4.768-11.113-.601-3.814-2.215-7.494-3.599-11.146-4.522-11.94-1.684-21.654 10.213-24.641.547-.14.938-.885 1.399-1.352M19.155 262.605c-9.166-.746-15.957-7.848-16.187-17.154-.167-6.678-.494-13.329-1.417-19.953-1.217-8.764 5.852-13.94 13.426-16.258 4.372-1.34 8.056 1.138 12.074 1.792'
      />
      <path
        stroke='#3455FC'
        strokeDasharray='5 5'
        strokeLinecap='round'
        strokeWidth={1.5}
        d='M295.63 262.605c9.166-.746 15.957-7.848 16.188-17.154.166-6.678.493-13.329 1.416-19.953 1.217-8.764-5.852-13.94-13.426-16.258-4.371-1.34-8.056 1.138-12.074 1.792M16.893 262.858c-7.911 2.495-12.535 8.03-15.136 15.754-1.374 4.071.928 7.702.675 11.634-.112 1.802.215 3.642-.08 5.567-1.271 8.341 5.374 16.027 13.822 15.121 5.697-.612 10.653 1.325 15.748 2.633 9 2.312 15.958-1.308 17.561-10.357.51-2.88 1.277-5.503 2.886-7.863 5.873-8.609 3.572-18.586-5.589-23.654-3.02-1.674-6.249-2.977-9.242-4.694-4.495-2.569-9.435-2.826-14.39-3.229M297.892 262.858c7.912 2.495 12.535 8.03 15.137 15.754 1.373 4.071-.928 7.702-.676 11.634.112 1.802-.215 3.642.08 5.567 1.271 8.341-5.374 16.027-13.822 15.121-5.697-.612-10.653 1.325-15.748 2.633-9.001 2.312-15.957-1.308-17.561-10.357-.51-2.88-1.277-5.503-2.886-7.863-5.873-8.609-3.572-18.586 5.589-23.654 3.02-1.674 6.249-2.977 9.242-4.694 4.495-2.569 9.435-2.826 14.391-3.229M45 75c2.444 2.003 4.685 4.23 7.708 5.184 4.544 1.43 7.807 5.401 10.622 10 6.46 10.567.142 23.197-7.745 24.873-1.337.284-2.67.605-3.999.943M42.684 68.805c-1.218-1.476-1.85-3.278-2.307-5.414-1.038-4.834 1.117-9 1.627-13.48.85-7.447 5.47-11.014 12.162-12.914 1.755-.496 3.54-.927 5.24-1.566 7.936-2.976 14.215-1.584 18.228 5.27 2.672 4.566 6.078 8.17 10.159 11.24 3.6 2.708 4.323 6.437 4.65 10.393.183 2.223-.005 4.475.043 6.716.085 3.813-1.633 6.102-5.21 7.852-6.168 3.018-12.617 1.727-18.944 1.823-1.846.03-3.613-.657-5.246.663L59.5 81M53.472 218.08c5.476 4.441 7.52 10.191 7.032 17.175-.22 3.143-.928 5.879-2.848 8.357-1.68 2.167-3.133 4.403-2.822 7.418.74 7.058-1.384 10.143-10.186 13.892M261.313 218.08c-5.476 4.441-7.52 10.191-7.032 17.175.22 3.143.928 5.879 2.849 8.357 1.678 2.167 3.132 4.403 2.821 7.418-.74 7.058 1.384 10.143 10.186 13.892M37.476 155.799c-5.745-3.116-11.72-3.121-17.658-2.553-7.938.751-14.643 9.253-14.793 17.969-.048 2.778-.14 5.53.681 8.405.773 2.703 0 5.803-.595 8.791-1.304 6.522.756 12.449 4.961 17.604M277.309 155.799c5.745-3.116 11.72-3.121 17.658-2.553 7.938.751 14.643 9.253 14.793 17.969.048 2.778.14 5.53-.681 8.405-.772 2.703 0 5.803.595 8.791 1.304 6.522-.756 12.449-4.961 17.604M15.86 148.66c-2.345-5.851-5.296-11.474-4.806-18.266.187-2.636.776-4.899 2.918-6.232 4.328-2.702 8.127-6.328 12.818-8.421 4.367-1.949 8.53-2.666 12.895 0 1.911 1.17 4.091 2.491 6.162 2.528 6.122.114 9.542 4.886 13.858 8.391 6.564 5.332 5.352 18.399-1.916 23.647-4.708 3.397-9.47 5.568-14.289 6.358M43.921 72.233c-7.343.44-13.51 3.973-19.732 7.556-4.681 2.697-7.99 8.291-6.831 13.634 1.49 6.877 2.79 13.905 7.392 19.587M114 17c1.806-4.942 5.032-8.651 9.702-9.873 6.588-1.728 13.054-4.056 20.238-2.74 4.119.755 7.93 1.306 11.06 4.213M260.399 120c-1.389 1.546-2.746 3.145-4.169 4.62-7.063 7.313-4.467 19.911 1.821 24.876 4.139 3.264 8.447 5.03 12.949 6.504M72.555 33.397c1.503-11.485 10.821-14.48 20.079-17.493 2.957-.965 5.963-1.78 8.976-2.579 5.438-1.44 10.302 1.763 11.109 7.2.232 1.56.348 3.268 1.093 4.608 3.545 6.371 2.83 13.361 3.007 20.12.269 10.104-6.331 14.147-16.303 10.902-2.265-.737-4.3-2.087-6.516-2.937M284.5 116.5c4.5-.5 7.664 3.266 14.656 7.132 4.649 2.568 5.839 10.625 3.208 17.632-1.068 2.846-4.125 7.45-5.364 10.236M240.473 32.786c-.437-10.883-9.566-13.001-17.143-16.34-3.223-1.421-6.877-2.16-10.339-3.064-3.366-.88-7.044-.416-9.8 2.422M225 55c-.596 1.412-1.562 3.93-1.888 5.338-1.727 7.434-.236 17.336 10.892 18.077 4.727.319 12.775.79 17.496 0'
      />
      <BodySelectButton
        id='o-tooth32'
        selectedKeys={selectedKeys}
        cx={287}
        cy={289}
        r={12}
        d='M283.004 289h8M287 285.001v8'
      />

      <BodySelectButton
        id='o-tooth31'
        selectedKeys={selectedKeys}
        cx={285}
        cy={236}
        r={12}
        d='M281.004 236h8M285 232.001v8'
      />

      <BodySelectButton
        id='o-tooth30'
        selectedKeys={selectedKeys}
        cx={281}
        cy={183}
        r={12}
        d='M277.004 183h8M281 179.001v8'
      />

      <BodySelectButton
        id='o-tooth29'
        selectedKeys={selectedKeys}
        cx={277}
        cy={134}
        r={12}
        d='M273.004 134h8M277 130.001v8'
      />

      <BodySelectButton
        id='o-tooth28'
        selectedKeys={selectedKeys}
        cx={271}
        cy={96}
        r={12}
        d='M267.004 96h8M271 92.001v8'
      />

      <BodySelectButton
        id='o-tooth27'
        selectedKeys={selectedKeys}
        cx={250}
        cy={59}
        r={12}
        d='M246.004 59h8M250 55.001v8'
      />

      <BodySelectButton
        id='o-tooth26'
        selectedKeys={selectedKeys}
        cx={215}
        cy={35}
        r={12}
        d='M211.004 35h8M215 31.001v8'
      />

      <BodySelectButton
        id='o-tooth25'
        selectedKeys={selectedKeys}
        cx={178}
        cy={25}
        r={12}
        d='M174.004 25h8M178 21.001v8'
      />

      <BodySelectButton
        id='o-tooth24'
        selectedKeys={selectedKeys}
        cx={137}
        cy={23}
        r={12}
        d='M133.004 23h8M137 19.001v8'
      />

      <BodySelectButton
        id='o-tooth23'
        selectedKeys={selectedKeys}
        cx={98}
        cy={36}
        r={12}
        d='M94.004 36h8M98 32.001v8'
      />

      <BodySelectButton
        id='o-tooth22'
        selectedKeys={selectedKeys}
        cx={65}
        cy={58}
        r={12}
        d='M61.004 58h8M65 54.001v8'
      />

      <BodySelectButton
        id='o-tooth21'
        selectedKeys={selectedKeys}
        cx={41}
        cy={96}
        r={12}
        d='M37.004 96h8M41 92.001v8'
      />

      <BodySelectButton
        id='o-tooth20'
        selectedKeys={selectedKeys}
        cx={37}
        cy={135}
        r={12}
        d='M33.004 135h8M37 131.001v8'
      />

      <BodySelectButton
        id='o-tooth19'
        selectedKeys={selectedKeys}
        cx={33}
        cy={183}
        r={12}
        d='M29.004 183h8M33 179.001v8'
      />

      <BodySelectButton
        id='o-tooth18'
        selectedKeys={selectedKeys}
        cx={29}
        cy={236}
        r={12}
        d='M25.004 236h8M29 232.001v8'
      />

      <BodySelectButton
        id='o-tooth17'
        selectedKeys={selectedKeys}
        cx={27}
        cy={289}
        r={12}
        d='M23.004 289h8M27 285.001v8'
      />
    </svg>
  );
};
export default DentalLowerButtons;
